import useUpdatePoolTaskSubmissions from '../../../../../hooks/useUpdatePoolTaskSubmissions'
import SharedEmailTask, {
  Props,
} from '../../../../../shared_components/Missions/Types/Email'
import TaskAllocationAmount from '../../../../../shared_components/Missions/TaskAllocationAmount'

export default function EmailTask(
  props: Omit<Props, 'updateTaskSubmissions' | 'taskAmount'>,
) {
  const updateTaskSubmissions = useUpdatePoolTaskSubmissions()
  return (
    <SharedEmailTask
      {...props}
      updateTaskSubmissions={updateTaskSubmissions}
      taskAmount={<TaskAllocationAmount taskId={props.taskId} />}
    />
  )
}
